// The redirect to the other build adds _rl=1; a request with it is served by the build that it reaches.
export const LOOP_GUARD_PARAM = '_rl';

// The path, query and hash without _rl, or undefined when the URL has no _rl.
export const withoutLoopGuard = (href: string): string | undefined => {
  const url = new URL(href);
  if (!url.searchParams.has(LOOP_GUARD_PARAM)) {
    return undefined;
  }

  url.searchParams.delete(LOOP_GUARD_PARAM);
  return `${url.pathname}${url.search}${url.hash}`;
};
